import React, {useState} from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import {TextField, Snackbar, Alert} from "@mui/material";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import {useNavigate} from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { db } from "../../FireBase/firestore";
import { collection, query, where, getDocs, updateDoc } from "firebase/firestore";

const LoginForm = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [resetPassword, setResetPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 834;
    const isMobile = window.innerWidth <= 440;
    const [snackbar, setSnackbar] = useState({open:false, severity:'success', message:''});
    const showMessage = (severity,message)=>{
        setSnackbar({
            open:true,
            severity,
            message
        })
    }
    const handleCloseSnackbar = ()=>{setSnackbar({...snackbar,open:false})}
    const handleResetPassword = async () => {
        if (!email.trim()) {
            showMessage("error", "Please enter your email");
            return;
        }
        if (!resetPassword.trim()) {
            showMessage("error", "Please enter new password");
            return;
        }
        try {
            setLoading(true);
            // 1. Check if email exists
            const q = query(
                collection(db, "users"),
                where("email", "==", email)
            );
            const querySnapshot = await getDocs(q);
            if (querySnapshot.empty) {
                setLoading(false);
                showMessage("error", "Invalid Email - User not found");
                return;
            }
            // 2. Get user doc
            const userDoc = querySnapshot.docs[0];
            // 3. Update password
            await updateDoc(userDoc.ref, {
                password: resetPassword
            });
            setLoading(false);
            showMessage("success", "Password Reset Successfully");
            setTimeout(() => {
                navigate("/login");
            }, 2000);
        } catch (error) {
            setLoading(false);
            showMessage("error", error.message);
        }
    };

    return (
        <div className="bg-offWhite p-0">
            <NavBar/>
            <div style={{paddingTop: isMobile ? "4rem" : isTablet ? "0" : "7rem"}}>
                <Container className="d-flex justify-content-center align-items-center min-vh-100">
                    <Row className="w-100 justify-content-center">
                        <Col md={12} lg={5}>
                            <div className="p-4 shadow" style={{ backgroundColor: '#fff', borderRadius: '20px' }}>
                                <div className="d-flex justify-content-center">
                                    <h2 className="text-green fw-bold pt-3">Forgot Password</h2>
                                </div>
                                <Col>
                                    <Col lg={12} className="mb-4 mt-5">
                                        <TextField label="Enter E-mail*" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-100"/>
                                    </Col>
                                    <Col lg={12} className="mb-4">
                                        <TextField label="Re-set Password*" type="password" value={resetPassword} onChange={(e)=>setResetPassword(e.target.value)} className="w-100"/>
                                    </Col>
                                    <Button style={{ backgroundColor: '#A6CE3A', borderColor: '#A6CE3A' }} className="w-100 rounded-pill fw-bold text-white" onClick={handleResetPassword} disabled={loading}>
                                        {loading ? <CircularProgress size={24} color="inherit"/> : "Re-set Password"}
                                    </Button>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer/>
            </div>
            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>{snackbar.message}</Alert>
            </Snackbar>
        </div>
    );
};
export default LoginForm;